import { dayFilter, mineOnly } from '../state/filters';
import { week } from '../state/schedule';
import { techName } from '../state/session';

/** Horizontal day filter strip + the Mine toggle (shown when any call is assigned). */
export function DayChips() {
  const days = week.value?.days ?? [];
  const anyAssigned = days.some((d) => d.calls.some((c) => c.tech));
  const chip = (active: boolean) =>
    `tap shrink-0 rounded-full px-4 py-2 text-sm font-semibold ${
      active ? 'bg-navy-900 text-white' : 'bg-white text-navy-900 border border-slate-300'
    }`;
  return (
    <nav
      class="scrollbar-none sticky top-[var(--chips-top,64px)] z-20 flex gap-2 overflow-x-auto bg-canvas px-3 py-2"
      aria-label="Day filter"
    >
      <button class={chip(dayFilter.value === 'all')} onClick={() => (dayFilter.value = 'all')}>
        All
      </button>
      {days.map((d) => (
        <button
          key={d.key}
          class={chip(dayFilter.value === d.key)}
          onClick={() => (dayFilter.value = d.key)}
        >
          {(d.label || d.key).split(',')[0]}
        </button>
      ))}
      {anyAssigned && techName.value && (
        <button
          class={`${chip(mineOnly.value)} ${mineOnly.value ? '!bg-brand-600' : ''}`}
          aria-pressed={mineOnly.value}
          onClick={() => (mineOnly.value = !mineOnly.value)}
        >
          Mine
        </button>
      )}
    </nav>
  );
}
